// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3Lwpj","avatar":"style_avatar__K0aW3","menuIcon":"style_menuIcon__bSm48"};